const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Edit Files Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the Analyze resource
 * @argument {Files} Files injected to gain access to the Files resource
 */
app.controller('editFile', ['Application', 'Authorization', 'Analyze', 'Files', 'AdminContent', 'Viewables', 'AccessHelper', 'SurveyHelper', '$scope', '$translate', '$filter', function (Application, Authorization, Analyze, Files, AdminContent, Viewables, AccessHelper, SurveyHelper, $scope, $translate, $filter) {
  var self = this;
  var routeParameters = Application.navigation.getRouteParameters();
  self.newFile = routeParameters.id === 'new' || !routeParameters.id;
  self.features = Application.features.flags();
  self.allowance = {
    create_file: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'files_create']], ['admin', 'creator', 'collaborator']),
    edit_file: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'files_edit'], ['admin', 'content', 'my_content_edit']], ['admin', 'creator', 'collaborator']),
    add_survey: self.features.surveys && AccessHelper.isAllowed(['admin', 'surveys'], null, ['admin']),
    add_partner: self.features.enable_partners && AccessHelper.isAllowed(['admin', 'content'], null, ['admin']),
  };

  if ((!self.newFile && !self.allowance.edit_file) || (self.newFile && !self.allowance.create_file)) {
    Application.navigation.goTo('/explore');
    return;
  }

  self.authtoken = Authorization.getAuthToken();
  self.user = self.authtoken.user;
  self.editSaved = true;
  self.backLocation = Application.navigation.history[Application.navigation.history.length - 2];
  self.denied = false;
  self.archiveInfo = {};

  var locationChange = $scope.$on('$locationChangeStart', function(event) {
    if (self.editSaved) {
      // Allow the route change to progress
      locationChange();
      Application.messaging.clearMessages('trackstate');
      return;
    }

    // Halt the route change and question the action
    self.navigationPath = {};
    self.navigationPath.targetPath = Application.navigation.getPath();
    self.navigationPath.targetSearch = Application.navigation.getUrlParameters();
    self.navigationPath.targetHash = Application.navigation.getHash();
    event.preventDefault();
    self.showDeparture = true;
    self.onLocationChange = async () =>{
        locationChange();
        Application.messaging.clearMessages('trackstate');
    };
  });

  var trackState = self.trackState = Application.trackState.get();
  if (trackState && trackState.ttl < new Date().valueOf()) {
    trackState = self.trackState = false;
  }
  if (trackState) {
    var trackTitle = trackState.trackTitle;
    if (self.newFile) {
      $translate('edit.files.add_track', {title: trackTitle})
      .then(function(value) {
        Application.messaging.addMessage({type: 'insidetrack', text: value, trackstate: true, link: '/edit/tracks/' + trackState.track});
      });
    }
    if (!self.newFile) {
      $translate('edit.files.edit_track', {title: trackTitle})
      .then(function(value) {
        Application.messaging.addMessage({type: 'insidetrack', text: value, trackstate: true, link: '/edit/tracks/' + trackState.track});
      });
    }
  }

  var file = {};
  file.type = 'file';
  file.tags = [];
  file.images = {};
  file.linked_category = [];
  file.explore_hide = trackState ? true : false;
  file.privacy_collaborators = [];
  file.allow_comments = false;
  file.use_generative_ai = !!Application.features.flags().enable_generative_ai;
  self.showCollaborators = false;
  self.activeTab = 'add';
  self.mediumOpts = {
    'targetBlank': true,
    'toolbar': {
      'buttons': ['bold', 'italic', 'underline', 'anchor', 'h1', 'h2', 'h3', 'quote', 'unorderedlist', 'orderedlist']
    }
  };

  self.navigationDirectory = {
    'add': {
      next: 'details',
      previous: null,
      required: ['link']
    },
    'details': {
      next: trackState ? 'settings' : 'images',
      previous: 'add',
      required: ['title', 'author', 'description']
    },
    'images': {
      next: 'categories',
      previous: 'details',
      required: null
    },
    'categories': {
      next: 'settings',
      previous: 'images',
      required: null
    },
    'settings': {
      next: 'preview',
      previous: trackState ? 'details' : 'categories',
      required: null
    },
    'preview': {
      next: null,
      previous: 'settings',
      required: null
    }
  };

  self.nextSection = function(item) {
    var nextClicked = item ? false : true;
    var item = item ? self.navigationDirectory[item].previous : self.activeTab;
    var next = self.navigationDirectory[item].next;
    var missing = '';
    var allow = true;

    var findIssues = function(check) {
      var current = self.navigationDirectory[check];
      if (self.file.use_generative_ai && check === 'details') {
        current.required = current.required.filter((x) => x !== 'description');
      }
        if (current.required) {
          for (var i = 0; i < current.required.length; i++) {
            if (!self.file[current.required[i]]) {
              allow = false;
            missing = missing + ' ' + (current.required[i] === 'link' ? 'file' : current.required[i]) + ',';
            }
          }
        }
      if (current.previous) {
        findIssues(current.previous);
      }
    };

    findIssues(item);

    if (allow && next) {
      if (self.newFile || !nextClicked) {
        if (next === 'details' && !self.file._id) {
          self.saveProgress().then(function () {
            self.activeTab = next;
            Application.scrollTop();
            return;
          });
        } else {
          self.saveProgress(next);
        }
        self.activeTab = next;
        Application.scrollTop();
        return;
      }
      self.saveProgress('next').then(function () {
        self.activeTab = next;
        Application.scrollTop();
      });
    }

    // Need to display messages on error
    if (missing) {
      Application.messaging.addMessage({type: 'error', text: self.translations['edit.general.notification_fieldsMissing'] + missing.slice(0, -1) + '.', duration: 5});
    }
  };

  self.saveProgress = function(next, publish) {
    self.updateIndicator = true;
    if(self.user.is_collaborator) {
      self.file.approval_required = true;
      self.file.approved = false;
    }
    if (publish) {
      self.file.draft = false;
    }

    if (!self.file._id && self.newFile && !next) {
      self.file.user = self.user._id;
      //requires title to save
      self.file.title = "Draft, Needs Title";
      self.file.draft = true;
      self.file.archived = !self.file.use_generative_ai;
      self.file.text_generation_status = self.file.use_generative_ai ? 'in_progress' : undefined;
      return Files.create(self.file).$promise.then(function(file) {
        self.updateIndicator = false;
        self.file = file;
        if (self.file.use_generative_ai) {
            self.getGeneratedText();
        }
      }).catch(function(error) {
        self.updateIndicator = false;
        if (error.data && error.data.status === 401 && error.data.message) {
          Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
        }
        console.log('Error in file Create: ', error);
      });
    } else {
      return Files.update({
        subresource: self.file._id,
        fields: 'title,description,type,author,duration,tags,images,link,source,source_id,video_type,type,user,linked_category,explore_hide,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,privacy_groups,private,downloadable,downloadable,cover_justification,featured_justification,completion_percent,embed,embed_settings,rating_configuration,rating_configuration,allow_comments,surveys,draft'
      }, self.file).$promise.then(function(file) {
        if (file.use_generative_ai) {
          self.getGeneratedText();
        }
        Analyze.record({resource: 'modifications'}, {document: file._id, type: 'file'});
        Application.analyticsProvider.trackEvent('file_updated', {content: file._id, content_type: 'file', title: file.title});
        self.updateIndicator = false;
        const fileName =
          $filter('limitTo')(self.file.title, 25) + (self.file.title.length > 25 ? '[...]' : '');
        
        self.editSaved = true;
        function goToTrack() {
          Application.navigation.goTo('/edit/tracks/' + trackState.track);
          $translate('modules.notifications.file_saved', {name: fileName}).then(function(data) {
            Application.messaging.addMessage({ type: 'success', text: data, duration: 5 });
          });
        }
        if (trackState && !next) {
          trackState.contentId = file._id;
          trackState.contentTitle = file.title;
          Application.trackState.set(trackState);
          goToTrack();
          return;
        }
        if (publish) {
          if (trackState) {
            goToTrack();
            return;
          }
          Application.navigation.goTo('/view/files/' + self.file._id);
          $translate('modules.notifications.file_published', { name: fileName }).then(function (
            data
          ) {
            Application.messaging.addMessage({ type: 'success', text: data, duration: 5 });
          });
        }
      }).catch(function(error) {
        self.updateIndicator = false;
        if (error.data && error.data.status === 401 && error.data.message) {
          Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
          return;
        }
        console.log('Error in update: ', error);
        Application.messaging.addMessage({type: 'error', text: self.translations['edit.files.update_issue'], duration: 5});
      })
    }
  };

  self.createFile = function() {
    if (!self.newFile) {
      return;
    }

    self.updateIndicator = true;
    self.file.draft = false;
    self.file.archived = false;
    Files.update({
      subresource: self.file._id,
      fields: 'title,description,type,author,duration,tags,images,link,source,source_id,video_type,type,user,linked_category,explore_hide,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,privacy_groups,private,downloadable,downloadable,cover_justification,featured_justification,completion_percent,embed,embed_settings,rating_configuration,rating_configuration,allow_comments,surveys,draft'
    }, self.file).$promise
    .then(function(file) {
      Analyze.record({resource: 'creations'}, {document: file._id, type: 'file'});
      Application.analyticsProvider.trackEvent('file_created', {content: file._id, content_type: 'file', title: file.title});
      self.updateIndicator = false;
      Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.file_createdPt1'] + ' ' + $filter('limitTo')(self.file.title, 25) + (self.file.title.length > 25 ? '[...]' : '') + ' ' + self.translations['modules.notifications.file_createdPt2'], duration: 5});
      self.editSaved = true;
      if (trackState) {
        trackState.contentId = file._id;
        trackState.contentTitle = file.title;
        Application.trackState.set(trackState);
        Application.navigation.goTo('/edit/tracks/' + trackState.track);
        return;
      }
      Application.navigation.goTo('/view/files/' + file._id);
    }).catch(function(error) {
      self.updateIndicator = false;
      if (error.data && error.data.status === 401 && error.data.message) {
        Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
      }
        console.log('Error in file Create: ', error);
    });
  };

  self.removeFile = function(next) {
    if (!self.file._id) {
      return;
    }

    self.archiveInfo = {};
    self.updateIndicator = true;
    return Viewables.archive({content: [{id: self.file._id, type: 'file'}]}).$promise
    .then(function(results) {
      self.archiveInfo.results = results;
      self.archiveInfo.show = results.in_track?.length || results.in_workflow?.length || results.in_journey?.length;
      self.updateIndicator = false;
      self.showDelete = false;
      if (self.archiveInfo.show) {
        return;
      }
      self.editSaved = true;
      Analyze.record({resource: 'deletions'}, {document: self.file._id, type: 'file'});
      Application.analyticsProvider.trackEvent('file_deleted', {content: self.file._id, content_type: 'file', title: self.file.title});
      Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.file_removed'], duration: 5});
      Application.navigation.goTo('/overview/content');
    }).catch(function(err) {
      self.editSaved = true;
      self.updateIndicator = false;
      self.showDelete = false;
      Application.messaging.addMessage({type: 'error', text: self.translations['edit.files.remove_issue'], duration: 5});
    });
  };

  self.goBack = function() {
    if (!self.denied || !self.backLocation) {
      Application.navigation.back();
      self.denied = true;
      return;
    }
    self.denied = true;
    var location = self.backLocation.split('/#/');
    if (location.length !== 2) {
      Application.navigation.back();
      return;
    }
    Application.navigation.goTo(location[1]);
  };

  self.surveyAssociation = {
    surveysData: [],
    surveyIds: [],
    omittedContentTypes: SurveyHelper.chipSearchOmittedContentTypes,
    initialIdsByType: {survey: []},
    initSurveyData: function() {
      self.surveyAssociation.initialIdsByType.survey = self.file.surveys;
      self.surveyAssociation.surveyIds.push(self.file.surveys[0].survey_id);
    }
  };

  self.partners = {
    partnerPermission: 'tenant',
    changePermission: (permission) => {
      self.partners.partnerPermission = permission;
    }
  }

  self.initialize = function () {
    if (self.user.role !== 'admin' && self.user.role !== 'creator' && !self.user.is_collaborator) {
      Application.navigation.goTo('/explore');
      return;
    }

    if (!Authorization.hasValidAuthToken()) {
      if (Application.navigation.isRouteSecure()){
        Application.navigation.goToSignIn();
      }
    }

    if (self.newFile) {
      self.file = file;
      if(self.user.is_collaborator) {
        self.file.privacy_collaborators.push(self.user._id);
      }
      self.startEditWatch();
      return;
    }

    // AdminContent.get({
    //   subresource: routeParameters.id,
    //   fields: 'title,company,description,type,author,duration,tags,images,link,source,source_id,source_v2,source_id_v2,video_type,type,user,linked_category,explore_hide,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,privacy_groups,private,downloadable,cover_justification,featured_justification,completion_percent,embed,embed_settings,rating_configuration,allow_comments',
    //   types: 'files'
    Files.get({
      fileId: routeParameters.id,
      fields: 'title,company,description,type,author,duration,tags,images,link,source,source_id,source_v2,source_id_v2,video_type,type,user,linked_category,explore_hide,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grade,privacy_groups,private,downloadable,cover_justification,featured_justification,completion_percent,embed,embed_settings,rating_configuration,allow_comments,surveys,partner_permissions,text_generation_status,use_generative_ai,draft'
    }).$promise.then(async function (data) {
      if (!data || (data.company !== self.authtoken.company._id)  || (self.user.is_collaborator && data.privacy_collaborators.length && data.privacy_collaborators.indexOf(self.user._id) === -1)) {
        Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.fileNotEditable'], duration: 5});
        self.editSaved = true;
        Application.navigation.goToHome();
      }
      self.file = data;
      if(!self.file.privacy_collaborators) {
        self.file.privacy_collaborators = [];
      }
      if(self.file.privacy_collaborators.length && !self.user.is_collaborator) {
        self.showCollaborators = true;
      }
      if (!self.file.images) {
        self.file.images = {};
      }
      if (self.file.surveys.length) {
        self.surveyAssociation.initSurveyData();
      }
      if (self.file.partner_permissions?.length) {
        self.partners.partnerPermission = self.file.partner_permissions;
      }
      if (self.file.use_generative_ai && self.file.text_generation_status === 'in_progress') {
        self.getGeneratedText();
      }
      self.startEditWatch();
    }).catch(function (error) {
      console.log('Error occured getting file ', routeParameters.id, error);
    });
  };

  self.startEditWatch = function() {
    $scope.$watch('file.file', function(newVal, oldVal) {
      if (!newVal || newVal === oldVal) {
        return;
      }
      self.editSaved = false;
    }, true);

    $scope.$watch('file.surveyAssociation.surveysData', function(newVal, oldVal) {
      if (!newVal || newVal === oldVal) {
        return;
      }
      self.surveyAssociation.surveyIds = newVal.map(survey => survey._id);
    }, true);

    $scope.$watch('file.surveyAssociation.surveyIds', function(newVal, oldVal) {
      if (!newVal || newVal === oldVal) {
        return;
      }
      self.file.surveys = newVal.map(surveyId => ({survey_id: surveyId}));
    }, true);
    $scope.$watch('file.partners.partnerPermission', function(newVal, oldVal) {
      if (!newVal || newVal === oldVal) {
        return;
      }
      self.file.partner_permissions = newVal;
    }, true);
  };

  self.getGeneratedText = function () {
    if (self.file.text_generation_status === 'completed') {
      return;
    }
    Files.get({
      fileId: self.file._id,
      fields: 'title,company,description,type,author,duration,tags,images,link,source,source_id,source_v2,source_id_v2,video_type,type,user,linked_category,explore_hide,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grade,privacy_groups,private,downloadable,cover_justification,featured_justification,completion_percent,embed,embed_settings,rating_configuration,allow_comments,surveys,partner_permissions,text_generation_status,use_generative_ai'
    }).$promise.then(async function (data) {
        const status = data.text_generation_status;
        if (status) {
          switch (status) {
            case 'in_progress':
              setTimeout(()=> {
                self.getGeneratedText();
              }, 15000);
              break;
            case 'completed':
              self.file.description = data.description;
              self.file.tags = data.tags;
              self.file.text_generation_status = 'completed';
            Application.messaging.addMessage({type: 'success', text: 'Text Generation Completed', duration: 7});
              break;
            case 'failed':
            Application.messaging.addMessage({type: 'error', text: 'Text Generation Failed', duration: 7});
              break;
            default:
              break;
          }
        }
    }).catch(function (error) {
        console.log('Error occurred getting file ', routeParameters.id, error);
      });
  }

  $translate([
    'edit.general.notification_fieldsMissing',
    'edit.general.notification_titleMissing',
    'edit.general.notification_confirmLeave',
    'modules.notifications.file_createdPt1',
    'modules.notifications.file_createdPt2',
    'modules.notifications.file_savedPt1',
    'modules.notifications.file_savedPt2',
    'modules.notifications.file_saved',
    'modules.notifications.file_published',
    'modules.notifications.file_removed',
    'modules.notifications.fileNotEditable',
    'edit.files.update_issue',
    'edit.files.remove_issue'
  ]).then(function(translations){
    self.translations = translations;
    self.initialize();
  });
}]);
